import React from 'react';
// import { FaHome } from "react-icons/fa";
import { MdAnnouncement } from "react-icons/md";
import { MdNewspaper } from "react-icons/md";
// import { BsFillCalendarEventFill } from "react-icons/bs";
import { GiHamburgerMenu } from "react-icons/gi";
import { MdDashboardCustomize } from "react-icons/md";
import { MdEvent } from "react-icons/md";
import { BiSolidReport } from "react-icons/bi";
import { SiActivitypub } from "react-icons/si";
import { GiPodiumWinner } from "react-icons/gi";
import { SiHelpdesk } from "react-icons/si";
import { RiGalleryFill } from "react-icons/ri";
import { VscFeedback } from "react-icons/vsc";
import { BiBriefcase } from "react-icons/bi";
import { FaBalanceScale } from 'react-icons/fa';
import { FaUserGraduate } from 'react-icons/fa';
import { IoMdContact } from 'react-icons/io';
import { FaBookOpen } from "react-icons/fa";
import { IoCalendarNumber } from "react-icons/io5";


export const IconsObject = {
    burgerMenu: (size = 25) => <GiHamburgerMenu size={size} />,
    dashboardIcon: (size = 25) => <MdDashboardCustomize size={size} />,
    announcementIcon: (size = 25) => <MdAnnouncement size={size} />,
    newsIcon: (size = 25) => <MdNewspaper size={size} />,
    eventIcon: (size = 25) => <MdEvent size={size} />,
    reportsIcon: (size = 25) => <BiSolidReport size={size} />,
    activityIcon: (size = 25) => <SiActivitypub size={size} />,
    achieversGalleryIcon: (size = 25) => <GiPodiumWinner size={size} />,
    helpDeskIcon: (size = 25) => <SiHelpdesk size={size} />,
    galleryIcon: (size = 25) => <RiGalleryFill size={size} />,
    feedbackIcon:(size = 25) => < VscFeedback size={size} />,
    applictaionIcon:(size = 25) => <BiBriefcase size={size} />,
    ombudsmanIcon:(size = 25) => <FaBalanceScale size={size} />,
    admissionIcon:(size = 25) => <FaUserGraduate size={size} />,
    contactIcon:(size = 25) => <IoMdContact size={size} />,
    bookIcon:(size = 25) => <FaBookOpen size={size} />,
    calendarIcon:(size = 25) => <IoCalendarNumber size={size} />,
};
